import { createFileRoute, redirect } from '@tanstack/react-router';

import { restoreSession } from '@/api/auth';
import { ChangePasswordForm } from '@/features/auth/ChangePasswordForm';
import { useAuthStore } from '@/stores/auth';

export const Route = createFileRoute('/change-password')({
  beforeLoad: async () => {
    if (!useAuthStore.getState().accessToken) {
      const restored = await restoreSession();
      if (!restored) {
        throw redirect({ to: '/login' });
      }
    }
  },
  component: ChangePasswordForm,
});
